import Section from '../Section';
import PredictiveSearch from '../global/PredictiveSearch';

export default class SearchBlock extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.theme = theme;
    this.element = element;

    this.theme.loadIcons();

    this.predictiveSearch = new PredictiveSearch(theme, element);
  }

  onSectionSelect = ({ element, sectionId, load }) => {
    this.theme.loadIcons();
  };
}
